import React from 'react';
import NotFoundImage from '@/assets/images/common/404.png';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Button } from '@mui/material';
import { BACKGROUND_COLORS, TEXT_COLORS } from '@/common/presentation/constants/colors';
import tid from '@/common/infrastructure/config/tid';

export const NotFound: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '2rem',
        boxSizing: 'border-box'
      }}
    >
      <div
        style={{
          width: '400px',
          height: '300px',
          margin: '1.5rem 0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <img src={NotFoundImage} alt="404 Illustration" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
      </div>
      <h1 style={{ fontSize: '24px', color: TEXT_COLORS.TEXT_PRIMARY, margin: 0 }}>Oops! page not found.</h1>
      <p style={{ textAlign: 'center', marginTop: '2em', maxWidth: '600px', color: TEXT_COLORS.TEXT_SECONDARY }}>
        It seems you’ve lost your way. The page you’re looking for doesn’t exist or has moved.
      </p>

      <div style={{ marginTop: '2rem', display: 'flex', gap: '1rem' }}>
        <Button
          onClick={() => {
            alert('Report an issue clicked');
          }}
          variant="outlined"
          sx={{ backgroundColor: BACKGROUND_COLORS.WHITE }}
          {...tid('common:not-found:report-issue-button')}
        >
          REPORT AN ISSUE
        </Button>

        <Button onClick={() => (window.location.href = '/')} variant="contained" {...tid('common:not-found:go-to-homepage-button')}>
          <ArrowForwardIcon style={{ marginRight: '0.2rem' }} />
          GO TO HOMEPAGE
        </Button>
      </div>
    </div>
  );
};
